import {
	createFileUploadSlice,
	initialFileState,
} from 'library/redux/fileUpload';

import { resetState } from './Thunk';

const commissioningFilesSlice = createFileUploadSlice({
	name: 'commissioningFiles',
	initialState: initialFileState,
	reducers: {},
	extraReducers(builder) {
		builder.addCase(resetState.fulfilled, () => initialFileState);
	},
});

export const { fileUploaded, fileDeleted, attachmentFolderCreated } =
	commissioningFilesSlice.actions;

export default commissioningFilesSlice.reducer;
